import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'slack-nudges',
});

export const notMyReportRouteRef = createRouteRef({
  id: 'slack-nudges-not-my-report',
});
